/** Parse lines 42, 43, 44 — voltage, current, stat type. */
export function parseLine424344(
  line: string
): { voltage: number; current: number; statType: string } | null {
  const parts = line.trim().split(/\s+/)
  if (parts.length >= 5) {
    return {
      voltage: parseFloat(parts[2]),
      current: parseCurrent(parts[3]),
      statType: parts[4]
    }
  }
  if (parts.length >= 4) {
    return {
      voltage: parseFloat(parts[1]),
      current: parseCurrent(parts[2]),
      statType: parts[3]
    }
  }
  return null
}

function parseCurrent(raw: string): number {
  const stripped = raw.replace(/^0+/, '')
  return stripped ? parseInt(stripped, 10) : 0
}

/** Heat input normalized to KJ/inch. */
export function parseHeatInput(line: string): number | null {
  const inchMatch = /(\d+\.?\d*)\s*KJ\/in(?:ch)?\b/i.exec(line)
  if (inchMatch) return parseFloat(inchMatch[1])
  const mmMatch = /(\d+\.?\d*)\s*KJ\/mm\b/i.exec(line)
  if (mmMatch) return parseFloat(mmMatch[1]) * 25.4
  return null
}

/** Travel speed normalized to inch/min. */
export function parseTravelSpeed(line: string): number | null {
  const inchMatch = /(\d+\.?\d*)\s*inch\/min/i.exec(line)
  if (inchMatch) return parseFloat(inchMatch[1])
  const cmMatch = /(\d+\.?\d*)\s*cm\/m(?:in)?\b/i.exec(line)
  if (cmMatch) return parseFloat(cmMatch[1]) * 0.3937007874
  return null
}

export function parseFinishTime(line: string): string | null {
  const match = /(\d{2}:\d{2}:\d{2})/.exec(line)
  return match ? match[1] : null
}
